module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_8004.4e475bdf.png";